import React from 'react';
import { ReactComponent as FacebookIcon } from 'Assets/svg/company-icon/facebook-logo.svg';
import { ReactComponent as TwitterIcon } from 'Assets/svg/company-icon/twitter-new-logo.svg';
import { ReactComponent as YoutubeIcon } from 'Assets/svg/company-icon/youtube-logo.svg';
import { ReactComponent as LinkedinIcon } from 'Assets/svg/company-icon/linkedin-logo.svg';

const SocialLinks = props => {
  const {
    facebookId = '',
    twitterId = '',
    youtubeId = '',
    linkedInId = '',
  } = props;

  const checkAndAddHttpProtocal = value => {
    if (value.includes('http://') || value.includes('https://')) return value;
    return `https://${value}`;
  };
  // console.log('SocialLinks ', props);
  return (
    <>
      {((facebookId !== '' && facebookId !== null) ||
        (twitterId !== '' && twitterId !== null) ||
        (youtubeId !== '' && youtubeId !== null) ||
        (linkedInId !== '' && linkedInId !== null)) && (
        <div className="social-links">
          {facebookId !== undefined &&
            facebookId !== '' &&
            facebookId !== null && (
              <div className="social-icon">
                <a
                  href={checkAndAddHttpProtocal(facebookId)}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FacebookIcon className="svg-icon facebook" />
                </a>
              </div>
            )}
          {twitterId !== undefined && twitterId !== '' && twitterId !== null && (
            <div className="social-icon">
              <a
                href={checkAndAddHttpProtocal(twitterId)}
                target="_blank"
                rel="noopener noreferrer"
              >
                <TwitterIcon className="svg-icon twitter" />
              </a>
            </div>
          )}
          {youtubeId !== undefined && youtubeId !== '' && youtubeId !== null && (
            <div className="social-icon">
              <a
                href={checkAndAddHttpProtocal(youtubeId)}
                target="_blank"
                rel="noopener noreferrer"
              >
                <YoutubeIcon className="svg-icon youtube" />
              </a>
            </div>
          )}
          {linkedInId !== undefined &&
            linkedInId !== '' &&
            linkedInId !== null && (
              <div className="social-icon">
                <a
                  href={checkAndAddHttpProtocal(linkedInId)}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <LinkedinIcon className="svg-icon linkedin" />
                </a>
              </div>
            )}
        </div>
      )}
    </>
  );
};

export default SocialLinks;
export { SocialLinks };
